import { ORCHESTRATION_SERVICE_API } from '../constants/AppConstants';

/**
 * Public sitemap building-data fetch — never send credentials/Authorization.
 * @param {string} encryptedReportId
 * @returns {Promise<{ok: boolean, json?: object, status?: number, error?: string}>}
 */
const getSitemapBuildingDataService = async (encryptedReportId) => {
  try {
    const response = await fetch(
      `${ORCHESTRATION_SERVICE_API}/v1/sitemap/building-data/${encodeURIComponent(encryptedReportId)}`,
      {
        method: 'GET',
        credentials: 'omit',
        skipAuthHeader: true,
        headers: {
          Accept: 'application/json',
        },
      },
    );

    const json = await response.json().catch(() => null);

    if (response.status !== 200) {
      return {
        ok: false,
        status: response.status,
        json,
        error: json?.errorDescription || 'Failed to fetch sitemap building data',
      };
    }

    return { ok: true, json };
  } catch (error) {
    return { ok: false, error: error.message };
  }
};

export default getSitemapBuildingDataService;
